/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=7613b243"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/KF23001/kf-mh-desktop-app-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__